import React, { useState, useEffect } from "react";
import { Patient } from "common/models/types";
import PatientInfoDisplay from "./PatientInfoDisplay";
import PatientInfoEditForm from "./PatientInfoEditForm";

interface PatientInfoTabProps {
  patient: Patient;
  onSavePatient?: (patient: Patient) => void;
  initialEditMode?: boolean;
}

const PatientInfoTab: React.FC<PatientInfoTabProps> = ({
  patient,
  onSavePatient,
  initialEditMode = false,
}) => {
  // 환자 정보 수정 모드 상태 관리
  const [isEditing, setIsEditing] = useState<boolean>(initialEditMode);

  // 신규 환자인지 확인 (ID가 없는 경우)
  const isNewPatient = !patient.id;

  // initialEditMode나 환자 ID가 변경될 때 편집 모드 상태 업데이트
  useEffect(() => {
    // 신규 환자이거나 initialEditMode가 true인 경우 편집 모드 활성화
    if (isNewPatient || initialEditMode) {
      setIsEditing(true);
    }
  }, [initialEditMode, isNewPatient]);

  // 수정 모드 시작 핸들러
  const handleStartEdit = () => {
    setIsEditing(true);
  };

  // 수정 취소 핸들러
  const handleCancelEdit = () => {
    // 신규 환자인 경우 편집 모드를 취소할 수 없음
    if (isNewPatient) return;
    setIsEditing(false);
  };

  // 저장 핸들러
  const handleSave = (updatedPatient: Patient) => {
    if (onSavePatient) {
      onSavePatient(updatedPatient);
    }
    // 저장 후 기존 환자만 편집 모드 종료 (신규 환자는 아직 ID가 없을 수 있음)
    if (!isNewPatient) {
      setIsEditing(false);
    }
  };

  // 항상 신규 환자는 편집 모드로 표시
  // 기존 환자는 isEditing 상태에 따라 표시
  return (
    <>
      {(isEditing || isNewPatient) && onSavePatient ? (
        <PatientInfoEditForm patient={patient} onSave={handleSave} onCancel={handleCancelEdit} />
      ) : (
        <PatientInfoDisplay patient={patient} onStartEdit={handleStartEdit} />
      )}
    </>
  );
};

export default React.memo(PatientInfoTab);
